import React, { useState } from "react";
import { Copy, Check, AlertTriangle, X } from "lucide-react";

export default function RevealModal({ title, subtitle, fields, warning, onClose }) {
  const [copiedIdx, setCopiedIdx] = useState(null);

  const doCopy = (value, idx) => {
    navigator.clipboard.writeText(value).catch(() => {});
    setCopiedIdx(idx);
    setTimeout(() => setCopiedIdx(null), 2000);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm" onClick={onClose}>
      <div
        className="glass-modal w-full max-w-md mx-4 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
        data-testid="reveal-modal"
      >
        <div className="flex items-center justify-between p-5 border-b border-[#7C5CFF]/[0.08]">
          <div>
            <p className="font-bold text-[#0B0F1A] text-sm">{title}</p>
            {subtitle && <p className="text-[10px] text-[#5B617A] mt-0.5">{subtitle}</p>}
          </div>
          <button onClick={onClose} data-testid="reveal-close" className="p-1.5 hover:bg-[#7C5CFF]/[0.06] rounded-lg">
            <X className="w-4 h-4 text-[#5B617A]" />
          </button>
        </div>

        <div className="p-5 space-y-3">
          {fields.map((f, i) => (
            <div key={i}>
              <label className="block text-[10px] font-semibold text-[#5B617A] uppercase tracking-wider mb-1">
                {f.label}
              </label>
              <div className="relative">
                <div
                  data-testid={`reveal-field-${i}`}
                  className={`w-full bg-white/60 border border-[#7C5CFF]/[0.12] rounded-xl p-3 pr-10 text-sm break-all ${f.mono ? "font-mono text-[#0B0F1A]" : "text-[#0B0F1A]"}`}
                >
                  {f.value}
                </div>
                {f.copyable && (
                  <button
                    data-testid={`reveal-copy-${i}`}
                    onClick={() => doCopy(f.value, i)}
                    className="absolute top-2 right-2 p-1.5 rounded-lg bg-white/80 border border-[#7C5CFF]/[0.12] hover:bg-[#7C5CFF]/[0.06] transition-colors"
                  >
                    {copiedIdx === i
                      ? <Check className="w-3.5 h-3.5 text-emerald-600" />
                      : <Copy className="w-3.5 h-3.5 text-[#5B617A]" />}
                  </button>
                )}
              </div>
            </div>
          ))}

          {warning && (
            <div className="flex items-start gap-2 bg-red-50 border border-red-200 rounded-xl p-3">
              <AlertTriangle className="w-4 h-4 text-red-500 mt-0.5 shrink-0" />
              <p className="text-xs text-red-700 font-medium">{warning}</p>
            </div>
          )}

          <button
            data-testid="reveal-done"
            onClick={onClose}
            className="w-full h-10 rounded-xl text-white font-semibold text-sm btn-primary-glass"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
